import { Typography } from "@material-ui/core";

import { CommonFormElProps } from "../types";

import styles from "./Copy.module.scss";

export type CopyProps = {
  readonly content: string[];
} & Omit<CommonFormElProps, "label">;

export const Copy = (props: CopyProps): JSX.Element => (
  <>
    {props.content.map((content) => (
      <Typography paragraph key={content.slice(0, 10)} className={styles.copy}>
        {content}
      </Typography>
    ))}
  </>
);
